import * as yup from 'yup'

export const addOccupationsSchema = yup.object({
	name: yup.string().required(),
})
